import {
  FEEDBACK_SUPPLIER_PROFILES,
  type FeedbackSupplierProfile,
} from '@erp/rpc';
import type { TranslateFn, UploadFileRejection } from 'src/lib/pricelist-utils';

/**
 * The run reads `.xlsx` only: both of its workbook readers stream through
 * ExcelJS's xlsx reader, which cannot read a legacy binary `.xls`, and the
 * upload URL is refused for one. Said at the drop, not after a 94 MB upload.
 */
export const HUBBELL_FEEDBACK_ACCEPT =
  '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function validateHubbellFeedbackFile(
  file: File,
  gt: TranslateFn,
  supplier: FeedbackSupplierProfile = FEEDBACK_SUPPLIER_PROFILES.hubbell,
): UploadFileRejection | null {
  if (/\.xlsx$/i.test(file.name)) return null;
  return {
    kind: 'unsupported',
    title: gt('Unsupported file format', {
      context:
        "toast title when a non-.xlsx file is dropped on a supplier's Feedback card",
    }),
    message: gt(
      '{supplier} Feedback reads .xlsx workbooks only: {results} and the Customer Sales Summaries.',
      {
        context:
          "toast message when a non-.xlsx file is dropped on a supplier's Feedback card; {supplier} is the supplier (Hubbell, ABB), {results} names its Results Workbook",
        supplier: supplier.name,
        results: supplier.resultsFileLabel,
      },
    ),
  };
}
